import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { getSystemAnnouncements } from "@/services/api/system";
import { useGlobalStore } from "@/store/hooks";
import { SoundOutlined } from "@ant-design/icons";
import { usePagination } from "ahooks";
import { Modal, Table } from "antd";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React from "react";

interface AnnouncementModalProps extends InjectBaseModalProps {}

/**
 * 公告列表弹框
 */
const AnnouncementModal: React.FC<AnnouncementModalProps> = function (props) {
    const { open, onCancel } = props;

    const globalStore = useGlobalStore();

    const shopId = globalStore.currentUser?.shopId;
    const shop = globalStore.shopMapping.get(shopId);
    const shopType = shop?.type;

    const { data, loading, pagination } = usePagination(
        async ({ current, pageSize }) => {
            const res = await getSystemAnnouncements({ pageNo: current, pageSize });

            return {
                list: res.items,
                total: res.totalCount,
            };
        },
        {
            defaultPageSize: 10,
        },
    );

    return (
        <Modal open={open} onCancel={onCancel} title="公告" footer={null}>
            <Table
                dataSource={data?.list}
                rowKey="id"
                pagination={pagination}
                loading={loading}
                columns={[
                    {
                        render(_, announcement) {
                            const { title, linkUrl, dateCreated, excludedShopTypes } = announcement;

                            const isHide = shopType && excludedShopTypes?.includes(shopType);

                            if (isHide) {
                                return null;
                            }

                            return (
                                <a target="_blank" href={linkUrl}>
                                    <SoundOutlined className="mr5" />
                                    {dateCreated ? <span>{moment(dateCreated).format("MM-DD")}: </span> : null}
                                    {title}
                                </a>
                            );
                        },
                    },
                ]}
            />
        </Modal>
    );
};

export default observer(AnnouncementModal);
